module.exports = __webpack_public_path__ + "static/media/steakhouse_teen-mb-fr.0bcf667c.jpg";